import {ComponentTypes} from '@dazn/lp-web/src/constants/componentTypes.constants';
import {IButton, IStandardRail} from '@dazn/lp-web/src/types';
import {railProxy} from '@dazn/lp-web/src/utils';
import {buttonProxy} from '@dazn/lp-web/src/proxies/button.proxy';

export function standardRailProxy(
    component: any,
    standardRail?: any
): IStandardRail | null {
    if (standardRail) {
        const rail = standardRail
            ? railProxy(standardRail, ComponentTypes.STANDARD_RAIL)
            : null;
        return {
            ...component,
            tiles: rail?.tiles ?? [],
            title: rail?.title,
            description: rail?.description
        };
    }

    const componentType = component?.fields?.componentType;
    const railId = component?.fields?.railId;

    let button = {} as IButton;
    component?.fields?.entries?.forEach(({fields, sys}: any) => {
        if (sys?.contentType?.sys?.id === 'LPButton') {
            button = buttonProxy(fields);
        }
    });

    if (!railId) {
        return null;
    }

    return {
        componentType,
        railId,
        button,
        railType: ComponentTypes.STANDARD_RAIL,
        title: '',
        description: '',
        tiles: [],
        railParams: component?.fields?.railParams
    };
}
